var React = require('react');

function Ball21 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M49.442,126.483c-1.23-1.759-2.389-3.519-3.7-5.158a120.067,120.067,0,0,0-13.765-13.661c-5.664-5.128-11.436-10.186-16.863-15.574A51.12,51.12,0,0,1,2.16,72.431,32.621,32.621,0,0,1,.9,53.358,26.007,26.007,0,0,1,49.548,48.94c.06.13.12.26.19.4.11.22.28.28.4.14a1.41,1.41,0,0,0,.18-.27,25.427,25.427,0,0,1,18.6-14.661,24.787,24.787,0,0,1,21.762,5.588,25.677,25.677,0,0,1,9.146,23.031,42.86,42.86,0,0,1-9.686,22.921,134.585,134.585,0,0,1-16.853,16.993q-8.137,7.324-16.05,14.854a38.2,38.2,0,0,0-6.787,8.867,2.2,2.2,0,0,1-.19.3c-.11.16-.49-.12-.83-.62Z","transform":"translate(-0.031 -33.956)"}));
}

Ball21.defaultProps = {"viewBox":"0 0 100 93.191"};

module.exports = Ball21;

Ball21.default = Ball21;
